import React from 'react';
import {
    CompetitiveRoundSummaries,
    CompetitiveRoundSummariesSmokeAbilitiesInnerCastPosition,
    Maps
} from "../../reckon-api";
import Box from "@mui/material/Box";
import {ImageOverlay, MapContainer, Polyline} from "react-leaflet";
import {LatLngExpression} from "leaflet";
import {CRS} from "leaflet";
import {useEffect, useRef, useState} from "react";
import 'leaflet/dist/leaflet.css';
import "./Map.css";
import {CircularProgress} from "@mui/material";
import PlayerOnMap from "./Markers/PlayerOnMap";

export function positionToMapBounds(position: {x:number, y:number}, map: Maps){
    return {
        y: (position.y - map.min_y) / (map.max_y - map.min_y),
        x: (position.x - map.min_x) / (map.max_x - map.min_x),
    }
}

// Use CompetitiveRoundSummariesSmokeAbilitiesInnerCastPosition as the position type
type SpecifiedPosition = CompetitiveRoundSummariesSmokeAbilitiesInnerCastPosition;

export function PositionMapRender(props: { map: Maps;
    id: string; children?: React.ReactNode;
    round_summaries: CompetitiveRoundSummaries[];
    timestamp_range: number[];
}) {
    const containerRef = useRef<HTMLDivElement>(null);
    const [containerSize, setContainerSize] = useState(null as number | null);
    console.log(props);

    useEffect(() => {
        if (containerRef.current) {
            const resizeObserver = new ResizeObserver((entries) => {
                for (let entry of entries) {
                    if (entry.contentRect) {
                        const size = Math.floor(Math.min(entry.contentRect.width, entry.contentRect.height));
                        setContainerSize(size+1);
                    }
                }
            });

            resizeObserver.observe(containerRef.current);

            return () => {
                resizeObserver.disconnect();
            };
        }
    }, []);

    const map_url = `https://res.cloudinary.com/xenesis/image/upload/c_scale,h_${containerSize},w_${containerSize}/valAssets/${props.map ? props.map.id : props.id}.png`;
    return (
        <Box
            ref={containerRef}
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {containerSize ? <MapContainer
                center={[containerSize / 2, containerSize / 2]}
                scrollWheelZoom={false}
                zoom={0}
                dragging={false}
                minZoom={0}
                maxZoom={0}
                attributionControl={false}
                zoomControl={false}
                doubleClickZoom={false}
                crs={CRS.Simple}
                bounds={[
                    [0, 0],
                    [containerSize, containerSize],
                ]}
            >
                <ImageOverlay
                    url={map_url}
                    bounds={[
                        [0, 0],
                        [containerSize, containerSize],
                    ]}
                />
                {
                    props.round_summaries.map((r, rIdx) => {
                        console.log(r.freeze_time_end_timestamp)
                        return r.positions[props.timestamp_range[1] + (r.freeze_time_end_timestamp as number)] ?
                            <PlayerOnMap key={rIdx} not_unique={true} prs={{
                                round: r,
                                position: r.positions[props.timestamp_range[1] + (r.freeze_time_end_timestamp as number)]
                            }} containerSize={containerSize} map={props.map} display_details={true}/> :
                            <PlayerOnMap key={rIdx} not_unique={true}
                                         prs={{round: r, position: r.positions[r.positions.length - 1]}}
                                         containerSize={containerSize} map={props.map} display_details={true}/>
                    })
                }
                {
                    props.round_summaries.flatMap(
                        (r, rIdx) => {
                            const position_set = r.positions?.slice(props.timestamp_range[0] + (r.freeze_time_end_timestamp as number), props.timestamp_range[1] + (r.freeze_time_end_timestamp as number));
                            return position_set.map(
                                (pos: SpecifiedPosition, index: number) => {
                                    if (index + 1 < position_set.length) {
                                        const posCoord = pos.position;
                                        const nextPosCoord = position_set[index + 1].position;
                                        if (!posCoord || posCoord.x === null || posCoord.y === null) return null;
                                        if (!nextPosCoord || nextPosCoord.x === null || nextPosCoord.y === null) return null;
                                        
                                        const position_normalized_from = positionToMapBounds({x: posCoord.x, y: posCoord.y}, props.map);
                                        position_normalized_from.x = position_normalized_from.x * containerSize;
                                        position_normalized_from.y = position_normalized_from.y * containerSize;

                                        const position_normalized_until = positionToMapBounds({x: nextPosCoord.x, y: nextPosCoord.y}, props.map);
                                        position_normalized_until.x = position_normalized_until.x * containerSize;
                                        position_normalized_until.y = position_normalized_until.y * containerSize;
                                        const line_position = [[position_normalized_from.x, position_normalized_from.y], [position_normalized_until.x, position_normalized_until.y]];
                                        return <Polyline key={`${rIdx}-${index}`} positions={line_position as LatLngExpression[]}
                                                         color={'white'}/>
                                    }
                                    return null;
                                }
                            )
                        }
                    )
                }

            </MapContainer> : <CircularProgress/>}
        </Box>
    );
}
